import 'ion-sound'

export const initializeIonSound = () => {
    ion.sound({
        sounds: [
            { name: 'applause', volume: 0.1, preload: false },
            { name: 'fireworks', volume: 0.5, preload: false },
            { name: 'fireworks_sales_platinum', volume: 0.2, preload: false },
            { name: 'fireworks_visa_approved', volume: 0.5, preload: false },
            { name: 'horn', volume: 0.5, preload: false },
            { name: 'door_bell', volume: 0.7, preload: false },
            { name: 'incoming_video_call', volume: 0.7, loop: 5, preload: false },
            { name: 'button_tiny', volume: 0.3, preload: false },
        ],
        volume: 0.5,
        path: window.location.origin + '/sounds/',
        preload: true,
    });
};